// Imports
import { faCreditCard, faMoneyBill1 } from '@fortawesome/pro-regular-svg-icons';
import { faComments, faSignOut, faUser, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { GetWebsiteResponse } from '../../../shareables/types/api/main/website/get';
import { GetMemberResponse } from '../../../shareables/types/api/main/website/member/get';
import planMapping from '../../../shareables/utils/billing/plan-mapping';


/** Function that generates an array of navigation items for a member based on the website's plan and member's information */
const memberNavigationItems = (member: GetMemberResponse, website: GetWebsiteResponse) => {
	// Return items
	return [
		...(member
			? [
					{
						type: 'link',
						to: '/account/member-settings',
						content: 'Member settings',
						icon: faUser,
						uniqueKey: 'member-settings',
					},
					{
						type: 'link',
						to: '/account/account-settings',
						content: 'Account settings',
						icon: faUsers,
						uniqueKey: 'account-settings',
					},
					...(website.plan >= planMapping.deluxe
						? [
								{
									type: 'link',
									to: '/account/communications/archive',
									content: 'Communications archive',
									icon: faComments,
									uniqueKey: 'communications-archive',
								},
								...(!member?.account?.approved ||
								(member?.account.approved &&
									((member?.notifications?.availablePaymentOptions ?? 0) > 0 ||
										(member?.payments?.storedPaymentMethods ?? 0) > 0))
									? [
											{
												type: 'link',
												to: '/payments/methods',
												content: 'Stored payment methods',
												icon: faCreditCard,
												uniqueKey: 'stored-payment-methods',
											},
										]
									: []),
								...(member?.payments?.hasPaymentHistory
									? [
											{
												type: 'link',
												to: '/payments/history',
												content: 'Online payment history',
												icon: faMoneyBill1,
												uniqueKey: 'online-payment-history',
											},
										]
									: []),
							]
						: []),
				]
			: []),
		{
			type: 'anchor',
			to: `https://${window.location.hostname}/oauth/sign-out?redirect-uri=${encodeURIComponent('/')}`,
			content: 'Sign out',
			icon: faSignOut,
			uniqueKey: 'sign-out',
		},
	];
};

export default memberNavigationItems;
